export default "__VITE_ASSET__BkzDMDd9__"